import {interfaceEncryptionLists, interfaceEncryptionLists2, interfaceEncryptionLists3} from "./CLIENTECTYPE66";
import {aesDeciphering, encryptJson} from '../globalFunction';

export const getQueryParams = function (url) {
    if (url.includes("?")) {
        const paramArr = url.slice(url.indexOf("?") + 1).split("&")
        const params = {}
        paramArr.map((param) => {
            const [key, val] = param.split("=")
            params[key] = decodeURIComponent(val)
        })
        return params
    } else {
        return ''
    }


}
export const setConfig = (config, xhr) => {
    if (config && config.url) {
        const isHave = interfaceEncryptionLists.some(item => {
            return config.url.includes(item)
        })
        const isHave2 = interfaceEncryptionLists2.some(item => {
            return config.url.includes(item)
        })
        const isHave3 = interfaceEncryptionLists3.some(item => {
            return config.url.includes(item)
        })
        if (isHave) {
            config.headers['CLIENTECTYPE'] = 66
            xhr.setRequestHeader('CLIENTECTYPE', 66);
        }
        if (isHave3) {
            config.headers['CLIENTECTYPE'] = 65
            xhr.setRequestHeader('CLIENTECTYPE', 65);
        }
        if (isHave2) {
            config.headers['ENCRYPT'] = true
            xhr.setRequestHeader('ENCRYPT', true);
            let params = getQueryParams(config.url)
            config.url = config.url.split('?')[0] + `?data=${encryptJson(params)}`
        }

    }
    return config
}


$.ajaxSetup({
    beforeSend: function (xhr, options) {
        options.headers = {}
        options = setConfig(options, xhr)
        var originalSuccess = options.success
        options.success = function (data, textStatus, jqXhr) {
            if(options&&options.url) {
                const isHave  = interfaceEncryptionLists.some(item=>{
                    return options.url.includes(item)
                })
                if(isHave) {
                    try {
                        data.data = aesDeciphering(data.data)
                    } catch (e) {

                    }
                }
            }
            originalSuccess.apply(this, arguments)
        }
    },
    // dataFilter: function (data,arg2) {
    //     //console.log(61,data,arg2)
    //     var result = '';
    //     try {
    //         if (data.data) {
    //
    //         }
    //     } catch (e) {
    //         return data
    //     } finally {
    //         return  result
    //     }
    // }
})





// WEBPACK FOOTER //
// ./resources/js/config/ajaxConfigSetting.js